import { useContext, useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { ConfigContext } from '../../../aurr/contexts/ConfigContext';
import { cacheTTLs } from '../../../common/constants';
import { ApiRequestProps } from '../../../common/interface';
import { getAxiosInstance } from '../../axiosCache';
import { BEEHIVE_QUERY_KEY } from '../constants';

export const useBeehiveQuery = ({
  baseURL,
  bypassCache = false,
  params = {},
  enabled = true,
}: ApiRequestProps) => {
  const { COMMUNITY_FUNCTIONS_URL } = useContext(ConfigContext);
  const axiosConfig = {
    baseURL: baseURL || COMMUNITY_FUNCTIONS_URL,
    ...(!bypassCache && {
      cache: {
        ttl: Math.min(cacheTTLs.articles, cacheTTLs.classes),
      },
    }),
  };

  const api = getAxiosInstance(bypassCache);
  const [isInitialLoaded, setInitialLoaded] = useState(false);
  const {
    isLoading: beehiveSearchLoading,
    error: beehiveSearchError,
    data: beehiveSearchData,
    ...rest
  } = useQuery({
    queryKey: [BEEHIVE_QUERY_KEY, baseURL, JSON.stringify(params || {})],
    queryFn: async () => {
      const response = await api.get(`/services/v2/index/search`, {
        ...axiosConfig,
        params,
      });

      if (!isInitialLoaded) {
        setInitialLoaded(true);
      }
      return response?.data || undefined;
    },
    enabled,
  });

  return {
    isLoading: beehiveSearchLoading,
    error: beehiveSearchError,
    data: beehiveSearchData || {},
    isInitialLoaded,
    ...rest,
  };
};
